import { isNullOrEmpty } from "../lib/helper";

const DE = require('../localization/de.json');
const EN = require('../localization/en.json');
const PL = require('../localization/pl.json');
const ES = require('../localization/es.json');
const FR = require('../localization/fr.json');
const MS = require('../localization/ms.json');

const languages: any = { de: DE, en: EN, pl: PL, es: ES, fr: FR, ms: MS }

export class LocalizationService {
    private language: string = "en";

    constructor(language: string) {
        if (language === "de" || language === "pl") {
            this.language = language;
        }
    }

    public supportedCultures: { translationKey: string, key: string, includeInBkcAppPage: boolean, includeInGetStartedPage: boolean }[] = [
        { translationKey: "English", key: "en", includeInBkcAppPage: true, includeInGetStartedPage: true },
        { translationKey: "German", key: "de", includeInBkcAppPage: true, includeInGetStartedPage: true },
        { translationKey: "Polish", key: "pl", includeInBkcAppPage: true, includeInGetStartedPage: true },
        { translationKey: "Spanish", key: "es", includeInBkcAppPage: true, includeInGetStartedPage: false },
        { translationKey: "French", key: "fr", includeInBkcAppPage: true, includeInGetStartedPage: false },
        { translationKey: "Malay", key: "ms", includeInBkcAppPage: true, includeInGetStartedPage: false }
    ];

    public supportedCountries: { translationKey: string, key: string, defaultLanguageKey: string }[] = [
        { translationKey: "Switzerland", key: "ch", defaultLanguageKey: "de" }
    ];

    public isValidCulture(lang: string, pathname: string, newUrl?: string): boolean {
        return this.supportedCultures.filter(
            (l) => {
                let include = l.includeInGetStartedPage;
                if (pathname.indexOf("bkcapp") !== -1 || (newUrl !== undefined && newUrl.indexOf("bkcapp") !== -1)) {
                    include = l.includeInBkcAppPage;
                }
                return (
                    l.key === lang &&
                    include
                );
            }).length > 0;
    }

    public isValidCountry(lang: string): boolean {
        return this.supportedCountries.filter((l) => l.key === lang).length > 0;
    }

    public setLanguage(lang: string, pathname: string) {
        if (this.isValidCulture(lang, pathname)) {
            this.language = lang;
        }
    }

    public getLocalizedText(key: string): string {
        if (
            !isNullOrEmpty(languages[this.language]) &&
            !isNullOrEmpty(languages[this.language][key])
        ) {
            return languages[this.language][key];
        }
        return key;
    }
}